import React from 'react';
import PropTypes from 'prop-types';
import { Toggle } from 'rsuite';

function Checkbox(props) {

  return (
    <div className={props.wrapperClass}>
      <Toggle
        className={props.checkboxClass}
        
        checkedChildren={props.checkedText}
        unCheckedChildren={props.uncheckedText}
        checked={props.value}
        onChange={(e) => { props.onChange(props.name, e) }}
      />
      {props.error.length > 0 && <div className="bg-red-500">{props.error}</div>}
    </div>
  );
}


// Define what props this element has (for debugging purposes only)
Checkbox.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.bool,
  error: PropTypes.string,
  checkedText: PropTypes.string,
  uncheckedText: PropTypes.string,
}

Checkbox.defaultProps = {
  error: "",
  value: false
}


export default Checkbox;